module.exports = __webpack_public_path__ + "static/media/instagram.faeaf517.png";